/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const SET_NOTIFICATIONS_MODAL_AUTO_OPENED_LOANS = 'app/Notifications/SET_NOTIFICATIONS_MODAL_AUTO_OPENED_LOANS';

export const FETCH_POST_AUTH_NOTIFICATIONS = 'app/Notifications/FETCH_POST_AUTH_NOTIFICATIONS';
export const FETCH_POST_AUTH_NOTIFICATIONS_FAILURE = 'app/Notifications/FETCH_POST_AUTH_NOTIFICATIONS_FAILURE';
export const FETCH_POST_AUTH_NOTIFICATIONS_SUCCESS = 'app/Notifications/FETCH_POST_AUTH_NOTIFICATIONS_SUCCESS';

export const RESET_POST_AUTH_NOTIFICATIONS = 'app/Notifications/RESET_POST_AUTH_NOTIFICATIONS';

export const SET_DESKTOP_NOTIFICATIONS_MODAL_OPEN = 'app/Notifications/SET_DESKTOP_NOTIFICATIONS_MODAL_OPEN';

export const SET_PRE_AUTH_NOTIFICATIONS = 'app/Notifications/SET_PRE_AUTH_NOTIFICATIONS';

// TODO: determine what error message should be, or if its even necessary
export const FETCH_NOTIFICATIONS_ERROR_MSG = 'There was an issue fetching the notifications data.';

/**
 * The notifications on CMS are set up for SS2, so the links in our
 * notifications point to SS2 routes/paths. The following dictionary is a
 * temporary workaround until we refactor how our notifications data is
 * returned.
 */
export const SS2_ROUTES_DICTIONARY = {
  '/disasterassistance': {
    desktop: '/help/disasterassistance',
    mobile: 'DisasterAssistance',
  },
  '/hardshipassistance': {
    desktop: '/help/hardshipassistance',
    mobile: 'HardshipAssistance',
  },
  '/learningvideos?video=how_to_read_your_escrow_statement': {
    desktop: '/help/learningcenter',
    mobile: 'LearningCenter',
  },
  '/learningvideos?video=mortgage_statement_overview_and_paperless_billing': {
    desktop: '/help/learningcenter',
    mobile: 'LearningCenter',
  },
  '/learningvideos?video=understanding_yearend_tax_documents': {
    desktop: '/help/learningcenter',
    mobile: 'LearningCenter',
  },
  '/lossdraft': {
    desktop: '/lossdraft',
    mobile: 'LossDraft',
  },
  '/lossdraft/message': {
    desktop: '/lossdraft/message',
    mobile: 'LossDraftMessageDetails',
  },
  '/securemessaging': {
    desktop: '/securemessaging',
    mobile: 'SecureMessaging',
  },
  '/settings': {
    desktop: '/settings', // TODO: update once settings implmented on desktop
    mobile: 'Settings',
  },
  '/statements': {
    desktop: '/documents/statements',
    mobile: 'Documents',
    mobileNestedScreen: 'Statements',
  },
  fallback: {
    desktop: '/payments',
    mobile: 'Payments',
  },
};

export const RELEASE_NOTIFICATIONS = [
  {
    content: [{
      inlineBlocks: [{
        text: 'Our newest release includes improved and enhanced self-service tools to make homeowner-ship more convenient and efficient. View and upload documents, manage automatic payments, and explore payment options with our most user-friendly design yet.',
        type: 'span',
      }],
      type: 'paragraph',
    }],
    date: 'July 25, 2022',
    lastUpdated: '2022-07-25T00:00:00+00:00',
    name: 'July 2022 Release Notes',
  },
  {
    content: [{
      inlineBlocks: [
        {
          text: 'You can still email your inquiries to ',
          type: 'span',
        },
        {
          data: {
            mail: 'mailto:customerservice@yourmortgageonline.com',
            url: '',
          },
          text: 'customerservice@yourmortgageonline.com',
          type: 'link',
        },
        {
          text: INTL_IDS.RELEASE_20220725_SECUREMESSAGING_BLOCK3_TEXT,
          type: 'span',
        },
      ],
      type: 'paragraph',
    }],
    date: 'July 25, 2022',
    lastUpdated: '2022-07-25T00:00:00+00:00',
    name: 'Secure messaging is temporarily unavailable',
  },
];

export const NEW_SECURE_MESSAGE_PROPS = {
  name: 'You have a new message from Customer Service',
  path: '/securemessaging',
  text: 'View in Secure Message Center',
};

export const NEW_LOSS_DRAFT_MESSAGE_PROPS = {
  name: 'You have a new message from Loss Draft Team',
  path: '/lossdraft',
  text: 'View in Claims Center',
};

export const LOSS_DRAFT_PENDING_ISSUE = {
  name: 'A new claims inquiry was submitted on your behalf',
  text: 'Hey there, we’re reviewing your inquiry right now! We will let you know once it’s resolved.',
};

export const SECURE_MESSAGING_PENDING_ISSUE = {
  name: 'A new inquiry was submitted on your behalf',
  text: 'Hey there, we’re reviewing your inquiry right now! We will let you know once it’s resolved.',
};

export const RESOLVED_STATUS = 'Resolved';
